module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-60x60-precomposed-5817fd375141e4c6689b9f27d32f8746.png";